import order from '../api/order';

import {
    GET_ORDER_LIST_BEGIN,
    GET_ORDER_LIST_SUCCESS,
    GET_ORDER_LIST_FAILURE,
    GET_ORDER_BEGIN,
    GET_ORDER_SUCCESS,
    GET_ORDER_FAILURE,
    CREATE_ORDER_BEGIN,
    CREATE_ORDER_SUCCESS,
    CREATE_ORDER_FAILURE,
    UPDATE_ORDER_DATA_BEGIN,
    UPDATE_ORDER_DATA_SUCCESS,
    UPDATE_ORDER_DATA_FAILURE,
    DELETE_ORDER_BEGIN,
    DELETE_ORDER_SUCCESS,
    DELETE_ORDER_FAILURE,
    GET_MANUAL_ORDER_LIST_BEGIN,
    GET_MANUAL_ORDER_LIST_SUCCESS,
    GET_MANUAL_ORDER_LIST_FAILURE,
    RESOLVE_ORDER_BEGIN,
    RESOLVE_ORDER_SUCCESS,
    RESOLVE_ORDER_FAILURE,
} from './types';

const initialState = {
    getOrderError: false,
    createOrderError: false,
    updateOrderError: false,
    deleteOrderError: false,
    listOrderError: false,
    orderData: {},
    orderList: {},
    // kept apart from orderList: the locker page shows both at once
    manualOrderList: {},
    listManualOrderError: false,
    resolveOrderError: false,
    // the order as resolve/ returned it: ahead of the refetched lists, and the only fresh
    // copy of an order the manual list doesn't include
    resolvedOrder: null,
};

const getters = {
    orderData:(state) => state.orderData,
    orderList:(state) => state.orderList,
    getOrderError:(state) => state.getOrderError,
    createOrderError:(state) => state.createOrderError,
    updateOrderError:(state) => state.updateOrderError,
    deleteOrderError:(state) => state.deleteOrderError,
    listOrderError:(state) => state.listOrderError,
    manualOrderList:(state) => state.manualOrderList,
    listManualOrderError:(state) => state.listManualOrderError,
    resolveOrderError:(state) => state.resolveOrderError,
    resolvedOrder:(state) => state.resolvedOrder,
};

const actions = {
    getOrder({ commit }, id) {
        commit(GET_ORDER_BEGIN);
        return order.getOrder(id)
            .then((response) => commit(GET_ORDER_SUCCESS, response.data))
            .catch((error) => commit(GET_ORDER_FAILURE, error.response?.data || { detail: error.message }));
    },
    getOrderList({ commit }, filter) {
        commit(GET_ORDER_LIST_BEGIN);
        return order.getOrderList(filter)
            .then((response) => commit(GET_ORDER_LIST_SUCCESS, response.data))
            .catch((error) => commit(GET_ORDER_LIST_FAILURE, error.response?.data || { detail: error.message }));
    },
    createOrder({ commit }, data) {
        commit(CREATE_ORDER_BEGIN);
        return order.createOrder(data)
            .then(() => commit(CREATE_ORDER_SUCCESS))
            .catch((error) => commit(CREATE_ORDER_FAILURE, error.response?.data || { detail: error.message }));
    },
    updateOrderData({ commit }, { id, data }) {
        commit(UPDATE_ORDER_DATA_BEGIN);
        return order.updateOrderData(id, data)
            .then(() => commit(UPDATE_ORDER_DATA_SUCCESS))
            .catch((error) => commit(UPDATE_ORDER_DATA_FAILURE, error.response?.data || { detail: error.message }));
    },
    deleteOrder({ commit }, orderId) {
        commit(DELETE_ORDER_BEGIN);
        return order.deleteOrder(orderId)
            .then(() => commit(DELETE_ORDER_SUCCESS))
            .catch((error) => commit(DELETE_ORDER_FAILURE, error.response?.data || { detail: error.message }));
    },
    getManualOrderList({ commit }, filter) {
        commit(GET_MANUAL_ORDER_LIST_BEGIN);
        return order.getOrderList(filter)
            .then((response) => commit(GET_MANUAL_ORDER_LIST_SUCCESS, response.data))
            .catch((error) => commit(GET_MANUAL_ORDER_LIST_FAILURE, error.response?.data || { detail: error.message }));
    },
    resolveOrder({ commit }, { id, data }) {
        commit(RESOLVE_ORDER_BEGIN);
        return order.resolveOrder(id, data)
            .then((response) => commit(RESOLVE_ORDER_SUCCESS, response.data))
            .catch((error) => commit(RESOLVE_ORDER_FAILURE, error.response?.data || { detail: error.message }));
    },
};

const mutations = {
    [GET_ORDER_LIST_BEGIN](state) {
        state.listOrderError = false;
    },
    [GET_ORDER_LIST_SUCCESS](state, data) {
        state.orderList = data;
        state.listOrderError = false;
    },
    [GET_ORDER_LIST_FAILURE](state, data) {
        state.listOrderError = data;
    },
    [GET_ORDER_BEGIN](state) {
        state.getOrderError = false;
        state.orderData = {};
    },
    [GET_ORDER_SUCCESS](state, data) {
        state.orderData = data;
        state.getOrderError = false;
    },
    [GET_ORDER_FAILURE](state, data) {
        state.getOrderError = data;
    },
    [CREATE_ORDER_BEGIN](state) {
        state.createOrderError = false;
    },
    [CREATE_ORDER_SUCCESS](state) {
        state.createOrderError = false;
    },
    [CREATE_ORDER_FAILURE](state, data) {
        state.createOrderError = data;
    },
    [UPDATE_ORDER_DATA_BEGIN](state) {
        state.updateOrderError = false;
    },
    [UPDATE_ORDER_DATA_SUCCESS](state) {
        state.updateOrderError = false;
    },
    [UPDATE_ORDER_DATA_FAILURE](state, data) {
        state.updateOrderError = data;
    },
    [DELETE_ORDER_BEGIN](state) {
        state.deleteOrderError = false;
    },
    [DELETE_ORDER_SUCCESS](state) {
        state.deleteOrderError = false;
    },
    [DELETE_ORDER_FAILURE](state, data) {
        state.deleteOrderError = data;
    },
    [GET_MANUAL_ORDER_LIST_BEGIN](state) {
        state.listManualOrderError = false;
    },
    [GET_MANUAL_ORDER_LIST_SUCCESS](state, data) {
        state.manualOrderList = data;
        state.listManualOrderError = false;
    },
    [GET_MANUAL_ORDER_LIST_FAILURE](state, data) {
        state.listManualOrderError = data;
    },
    [RESOLVE_ORDER_BEGIN](state) {
        state.resolveOrderError = false;
    },
    [RESOLVE_ORDER_SUCCESS](state, data) {
        state.resolvedOrder = data;
        state.resolveOrderError = false;
    },
    [RESOLVE_ORDER_FAILURE](state, data) {
        state.resolveOrderError = data;
    },
};

export default {
    namespaced: true,
    state: initialState,
    getters,
    actions,
    mutations,
}; 